<div class="header">
  <h1>Customer Mailing Requests</h1>
  <mat-chip-list>
    <mat-chip color="primary" selected class="count-chip">{{
      mailingRequestArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>

<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Mailing Requests</mat-label>
        <input
          matInput
          (keyup)="filterMailingRequests($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="mailing-request-table"
      matSort
      fixedLayout="false"
    >
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.customerName || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Mailing Address
        </th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.customerAddress || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerEmail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.customerEmail || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Email Requested
        </th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.email || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="mail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Mail Requested
        </th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.mail || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Request Notes</th>
        <td mat-cell *matCellDef="let mailingRequest">
          {{ mailingRequest.notes || "n/a" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No mailing requests found.
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToMailingRequest(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
